import React from "react";
import { createContext, useReducer, useContext } from "react";
import { v4 as uuidv4 } from "uuid";

import * as ACTION from "./action";

const ServiceWorksheetContext = createContext();

const serviceWorksheetReducer = (state, action) => {
  switch (action.type) {
    case ACTION.UPDATE_SEARCH_CRITERIA: {
      return {
        ...state,
        search: {
          ...state.search,
          uuid: uuidv4(),
          salesOrderNumber: action.salesOrderNumber,
          templateId: action.templateId,
          userIds: action.userIds,
          date: action.date,
          status: action.status,
          offset: action.offset,
          limit: action.limit,
        },
        results: {
          ...state.results,
          serviceWorksheet: null,
        },
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
};

export const ServiceWorksheetProvider = ({ children }) => {
  const [state, dispatch] = useReducer(serviceWorksheetReducer, {
    search: {
      uuid: uuidv4(),
      salesOrderNumber: null,
      templateId: null,
      userIds: null,
      date: null,
      status: null,
      offset: 0,
      limit: 10,
    },
  });
  const value = { state, dispatch };

  return (
    <ServiceWorksheetContext.Provider value={value}>
      {children}
    </ServiceWorksheetContext.Provider>
  );
};

export const useServiceWorksheet = () => {
  const context = useContext(ServiceWorksheetContext);
  if (context === undefined) {
    throw new Error(
      "useServiceWorksheet must be used within a ServiceWorksheetProvider",
    );
  }
  return context;
};
